var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"map",attrs:{"id":"map"}},[(_vm.redrawShape)?_c('a-button',{staticStyle:{"position":"absolute","top":"10px","right":"10px","z-index":"100"},on:{"click":function($event){return _vm.reDraw(_vm.drawType)}}},[_vm._v(" 重新绘制 ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }